'use strict';

module.exports = (app) => app.controller('taskCountController', /* @ngInject */ function ($scope, taskService) {

    $scope.toTaskList = toTaskList;
    $scope.loading = false;

    init();

    function init() {
        $scope.loading = true;
        taskService.getTaskCountExtended().then(
            /**
             * @param count {({myTasks: number, otherTasks: number})}
             */
            count => {
                $scope.myTasks = count.myTasks;
                $scope.otherTasks = count.otherTasks;
                $scope.loading = false;
                $scope.$apply();
            });
    }

    function toTaskList(state) {
        const iframeRouteBase = 'client/task/list';
        const iframeRouteWithQuery = `${iframeRouteBase}${state ? '?display='+state : ''}`;
        window.setIFrameRoute(iframeRouteWithQuery);
        window.openContent('container.htm&if=' + iframeRouteWithQuery);
    }

});

